import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { SectionTitle } from "@/components/Bits";
import { BLOG_CATEGORIES } from "@/lib/constants";
import { useLang } from "@/context/LanguageContext";

export default function Blog() {
  const { t, lang } = useLang();
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("");
  const load = async () => { const { data } = await api.get("/blog", { params: cat ? { category: cat } : {} }); setPosts(data); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [cat]);
  const locale = lang === "en" ? "en-US" : "fr-FR";

  return (
    <div className="bg-ivory min-h-screen">
      <section className="bg-navy py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <SectionTitle light eyebrow={t("pages.blog.eyebrow")} title={t("pages.blog.title")} subtitle={t("pages.blog.subtitle")} />
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-10">
        <div className="flex flex-wrap gap-2 mb-8">
          <button onClick={() => setCat("")} data-testid="blog-cat-all" className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${!cat ? "bg-navy text-white" : "bg-white text-navy border"}`}>{t("pages.blog.all")}</button>
          {BLOG_CATEGORIES.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`blog-cat-${c}`} className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${cat === c ? "bg-navy text-white" : "bg-white text-navy border"}`}>{c}</button>
          ))}
        </div>
        {posts.length === 0 ? (
          <p className="text-slate-500 py-16 text-center">{t("pages.blog.none")}</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
            {posts.map((post) => (
              <Link key={post.id} to={`/blog/${post.slug}`} data-testid={`blog-card-${post.slug}`} className="group block rounded-xl bg-white border border-black/5 overflow-hidden card-hover">
                <div className="aspect-[16/10] overflow-hidden"><img src={post.image} alt={post.title} className="h-full w-full object-cover img-zoom" /></div>
                <div className="p-6">
                  <span className="font-mono text-[11px] uppercase tracking-wider text-gold">{post.category}</span>
                  <h3 className="mt-2 font-serif text-xl font-semibold text-navy line-clamp-2">{lang === "en" && post.title_en ? post.title_en : post.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 line-clamp-2">{lang === "en" && post.excerpt_en ? post.excerpt_en : post.excerpt}</p>
                  <div className="mt-4 text-xs text-slate-400">{post.author} · {new Date(post.created_at).toLocaleDateString(locale)}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
